import { render, staticRenderFns } from "./EditarEdital.vue?vue&type=template&id=654c6af2&scoped=true"
import script from "./EditarEdital.vue?vue&type=script&lang=ts"
export * from "./EditarEdital.vue?vue&type=script&lang=ts"
import style0 from "./EditarEdital.vue?vue&type=style&index=0&id=654c6af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654c6af2",
  null
  
)

export default component.exports